/**
 * This component just glues the redux-form and react-toggle
 * implementations together
 * https://github.com/react-bootstrap/react-bootstrap/issues/2210#issuecomment-246933578
 */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import Toggle from 'react-toggle';
import styles from './styles.sass';
import { FieldToggleProps, FieldToggleWithReduxProps } from './types';

const FieldToggleWithRedux = ({
  input: { name, onChange, value },
  meta: { form },
  isDisabled,
  id,
  cssProp,
}: FieldToggleWithReduxProps) => (
  <FieldToggle
    cssProp={cssProp}
    name={name}
    id={id}
    form={form}
    onChange={onChange}
    value={value}
    isDisabled={isDisabled}
  />
);

const FieldToggle = ({
  name,
  form,
  value,
  onChange,
  isDisabled,
  id,
  cssProp,
}: FieldToggleProps) => {
  // redux form defaults value to an empty string, but we'll check
  // for a non-empty string too and assume that's true
  let isChecked = false;
  if (typeof value === 'string') isChecked = value.length > 0;
  if (typeof value === 'boolean') isChecked = value;
  return (
    <div className={styles.container} css={cssProp}>
      <Toggle
        disabled={isDisabled}
        id={id}
        aria-labelledby={`${form} ${name}`}
        icons={false}
        checked={isChecked}
        onChange={onChange}
      />
    </div>
  );
};

function FieldToggleDeprecated({
  children,
  input,
  ariaLabelledBy,
  meta: { submitFailed, error },
  handleValueOnChange,
}: any) {
  return (
    <div className={`${styles.withHorizontalToggle} ${styles.withSmallToggle}`}>
      {submitFailed && error && (
        <p className="text-danger text-center">{error}</p>
      )}
      <span id={input.name}>{children}</span>
      <Toggle
        aria-labelledby={ariaLabelledBy}
        icons={false}
        checked={input.value}
        onChange={() => {
          input.onChange(!input.value);
          if (handleValueOnChange) handleValueOnChange(input.value);
        }}
      />
    </div>
  );
}

export { FieldToggle, FieldToggleWithRedux, FieldToggleDeprecated };
